var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "143", height: "50", viewBox: "0 0 143 50", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Shape"
    ),
    React.createElement(
      "g",
      { id: "Boost-&-incognito-in-line-promo", fill: "none", fillRule: "evenodd", opacity: ".299" },
      React.createElement(
        "g",
        { id: "Web---Incognito-top-banner", transform: "translate(-191 -8)", fill: "#34F", fillRule: "nonzero" },
        React.createElement("path", { d: "M329.213 8s-10.204 5.73-25.015 4.23c-14.81-1.5-26.786-4.203-41.698 13.21-14.911-17.415-26.887-14.713-41.698-13.21-14.81 1.5-25.014-4.23-25.014-4.23-7.9 17.387-6.598 33.352 8.229 44.461 22.39 16.777 58.483-9.908 58.483-9.908s36.096 26.685 58.484 9.908c14.825-11.11 16.128-27.074 8.229-44.461zM231.34 43C220.014 43 210 29 210 29c5.334 4.093 12 .669 21.34.034 9.34-.634 18.66 7.712 18.66 7.712S242.666 43 231.34 43zm62.32 0C282.334 43 275 36.746 275 36.746s9.318-8.346 18.66-7.712C303 29.67 309.668 33.091 315 29c0 0-10.014 14-21.34 14z", id: "Shape" })
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/routers/Desktop/HeaderBanner/Incognito/blue_mask.svg